import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { environment } from './../../../../../environment/environment';
import { SortDataService } from './../../../../core/services/sortdata';
import { Component, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ICandidat } from './../../../../core/models/candidat';
import {
  EmptyCV,
  obligationSelect,
  serverError,
} from './../../../../core/models/messages';
import { EsnCandidatService } from './../../../../core/services/esn-candidat/esn-candidat.service';
import * as JSZip from 'jszip';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { saveAs } from 'file-saver';
import { SalarieService } from './../../../../core/services/salarie-service/salarie.service';
import { Country, State } from 'country-state-city';
import { ActivatedRoute, Router } from '@angular/router';
import { EsnJobOfferService } from '@core/services/esn-job-offer-service/esn-job-offer.service';
import { PageEvent } from '@angular/material/paginator';
import { Subject, takeUntil } from 'rxjs';
import Swal from 'sweetalert2';
enum CompanyType {
  ESN = 'ESN',
  WGU = 'WGU'
}

@Component({
  selector: 'app-listecandidature',
  templateUrl: './listecandidature.component.html',
  styleUrls: ['./listecandidature.component.css'],
})
export class ListecandidatureComponent {
  parentItem = 'Oups, Aucune donnée disponible pour le moment.';
  minEndDate: Date | null = null; 
  maxStartDate: Date |null = null;
  freeSearch: boolean = false;
  compt = [
    { id: 1, name: 'Immédiate' },
    { id: 2, name: '2 mois' },
    { id: 3, name: '3 mois' },
    { id: 4, name: '4 mois' },
    { id: 5, name: '5 mois' },
  ];

  contrat = [
    { id: 1, name: 'Alternance' },
    { id: 2, name: 'Autres type de contrat' },
    { id: 3, name: 'CDD' },
    { id: 4, name: 'CDI' },
    { id: 5, name: 'Freelance' },
    { id: 6, name: 'Portage salarial' },
    { id: 7, name: 'Stage' },
  ];

  poste = [
    { id: 1, name: 'sur site' },
    { id: 2, name: 'à distance' },
    { id: 3, name: 'hybrid' },
  ];
  disponibilite = [
    { id: 1, name: 'Immédiate' },
    { id: 3, name: '2 mois' },
    { id: 4, name: '3 mois' },
    { id: 5, name: '4 mois' },
    { id: 6, name: '5 mois' },
  ];
  isCollapsed = true;
  toggleCollapsible() {
    this.isCollapsed = !this.isCollapsed;
  }
  private unsubscribeAll: Subject<void> = new Subject();
  stateList: any = [];
  loadSpinnerTable: boolean = false;
  pagination : boolean =false;
  listNames: string[] = [];
  dataHeader: any = [];
  loadSpinner: boolean = false;
  itemsPerPage: number = 5;
  pageSize = 5;
  pageSizeOptions = [5, 10, 20];
  currentPage: number = 0;
  currentSortDirection: number = 1;
  startIndex: number = 0;
  endIndex: number = 5;
  totalItems!: number;
  listcandidats: any;
  urlimage: string = environment.baseUrlGaleryy;
  urlcv: string = environment.baseUrlGaleryCv;
  url: string = environment.baseUrl + '/api';
  headerChecked: boolean = false;
  isLoadSpinner: boolean = true;
  typeintervenant: any;
  selectedCandidats: any = [];
  backGroundColors: string[] = [
    'blue',
    'orange',
    'bleu-clair',
    'pink',
    'rose',
    'jaune',
    'rouge',
  ];
  sortAttr = '';
  searchForm: FormGroup = this.createSearchForm();
  freeSearchForm: FormGroup = this.createFreeSearchForm();
  skillsList: { name_FR: string }[] = [];
  paysList: any[] = Country.getAllCountries().map((country) => ({
    ...country,
    name: this.translateCountryName(country.name),
  }));
  freeSearchActive :boolean = false;
  activeForm: 'freeSearch' | 'guidedSearch' | null = null;
  currentSortColumn: string = 'name'; // Initial column to sort by
  idoffre = this.activatedRoute.snapshot.params['id'];
  showModal = false;
  profile = [
    { id: 1, name: 'Oui' },
    { id: 0, name: 'Non' },
  ];
  passeport = [
    { id: 1, name: 'Oui' },
    { id: 0, name: 'Non' },
  ];
  state = [
    { id: 0, name: 'Actif' },
    { id: 1, name: 'Non Actif' },
  ];
  mobilities: any[] = [];
  countries: any = [];
  startSearching:boolean = false;
  candidateScoreDetail : any = null
  companyTypeEnum = CompanyType;
  btnSearchactive : boolean = false;
  offre_id = this.activeroute.snapshot.params['id'];
  constructor(
    private formBuilder: FormBuilder,
    private candidatservice: EsnCandidatService,
    private spinner: NgxSpinnerService,
    private toastrService: ToastrService,
    private salarieservice: SalarieService,
    private sortDataService: SortDataService,
    private activatedRoute: ActivatedRoute,
    private localStorageService: LocalStorageService,
    private elRef: ElementRef,
    private jobofferservice: EsnJobOfferService,
    private activeroute: ActivatedRoute,
    private router: Router
  ) {}
  ngOnInit() {
      this.typeintervenant = 
      this.localStorageService.getData('typeintervenant');
      this.countries = Country.getAllCountries();
    this.getListcandidat();
    this.getListSkills();
    this.getListElementHeader();
    const scrollableTable = this.elRef.nativeElement.querySelector('#kt_customers_table');
    scrollableTable?.addEventListener('scroll', this.closeDropdownOnScroll.bind(this));
     this.searchForm.get('start_date')?.valueChanges.subscribe((startDate) => {
      this.minEndDate = startDate ? new Date(startDate) : null;
    });
    this.searchForm.get('end_date')?.valueChanges.subscribe((endDate) =>{
      this.maxStartDate = endDate ? new Date(endDate) : null;
    })
  }
  closeDropdownOnScroll(): void {
    // Find the open dropdown
    const dropdown = this.elRef.nativeElement.querySelector('.dropdown-menu.show');
    
    // If the dropdown is open, remove the 'show' class to close it without triggering a page scroll
    if (dropdown) {
      dropdown.classList.remove('show');
    }
  }
  createFreeSearchForm(){
    return this.formBuilder.group({
      search: [
        '',
        [Validators.pattern(/^("([^"]*"(AND|NOT|,|&&)[^"]*)*"|[^\s"']+)$/)],
      ],
    });
  }
  setActiveForm(form: 'freeSearch' | 'guidedSearch') {
    this.activeForm = form;
    if (form === 'freeSearch') {
      this.freeSearchActive = true;
      this.freeSearchForm.enable(); 
    } else if (form === 'guidedSearch') {
      this.freeSearchActive = false;
      this.searchForm.enable();
    }
}
  onSubmit() {

    if(!this.freeSearchActive) { 
      
      this.btnSearchactive = true;
      this.currentPage = 0;
      this.searchCandidat();
    } else{
       
      this.btnSearchactive = true;
      this.currentPage = 0;
      this.freeSearchCandidat();
    }
  }
  displayFreeSearch() {
    this.freeSearch = !this.freeSearch;
    this.currentPage = 0;
    if(this.freeSearch) {
       this.searchForm.reset();
       this.freeSearchForm = this.createFreeSearchForm();

       //this.getListconsultant();
    }
    else {
       this.freeSearchForm.reset();
       this.searchForm = this.createSearchForm();
    }
      this.getListcandidat;

  }
  sortData(item: string) {
    this.sortAttr = item;
    this.currentSortDirection = this.currentSortDirection === 1 ? 2 : 1;
    this.currentPage = 1;
    this.endIndex = 5;
    // let sort={sort:this.currentSortDirection,sortAttribute:item}
    if (this.searchForm.value != '')
      this.listcandidats = this.sortDataService.sortArray(
        this.listcandidats,
        this.sortAttr,
        this.currentSortDirection
      );
    else this.getListcandidat();
  }
  getItems(event?: any) {
    if (event) {
      this.startIndex = event.startIndex;
      this.endIndex = event.endIndex;
      (this.itemsPerPage = event.itemsPerPage),
        (this.currentPage = event.currentPage);
      if (this.searchForm.dirty) {
        this.searchCandidat();
      } else if( (this.startIndex !=0 || this.endIndex !=5) || this.pagination == true){        this.pagination = true
        this.getListcandidat();
      }
    }
  }
   onPageChange(e: PageEvent): void {
      this.pageSize = e.pageSize;
      this.currentPage = e.pageIndex;
      if (this.searchForm.dirty) {
        this.onSubmit();
      } 
      else {
        this.getListcandidat();
      }
    }
  translateCountryName(name: string): string {
    const translations: { [key: string]: string } = {
      Afghanistan: 'Afghanistan',
      'South Africa': 'Afrique du Sud',
      Albania: 'Albanie',
      Algeria: 'Algérie',
      Germany: 'Allemagne',
      Andorra: 'Andorre',
      Angola: 'Angola',
      Anguilla: 'Anguilla',
      Antarctica: 'Antarctique',
      'Antigua and Barbuda': 'Antigua-et-Barbuda',
      'Saudi Arabia': 'Arabie saoudite',
      Argentina: 'Argentine',
      Armenia: 'Arménie',
      Aruba: 'Aruba',
      Australia: 'Australie',
      Austria: 'Autriche',
      Azerbaijan: 'Azerbaïdjan',
      Bahamas: 'Bahamas',
      Bahrain: 'Bahreïn',
      Bangladesh: 'Bangladesh',
      Barbados: 'Barbade',
      Belgium: 'Belgique',
      Belize: 'Belize',
      Benin: 'Bénin',
      Bermuda: 'Bermudes',
      Bhutan: 'Bhoutan',
      Belarus: 'Biélorussie',
      Bolivia: 'Bolivie',
      'Bosnia and Herzegovina': 'Bosnie-Herzégovine',
      Botswana: 'Botswana',
      Brazil: 'Brésil',
      Brunei: 'Brunei',
      Bulgaria: 'Bulgarie',
      'Burkina Faso': 'Burkina Faso',
      Burundi: 'Burundi',
      'Cape Verde': 'Cabo Verde',
      Cambodia: 'Cambodge',
      Cameroon: 'Cameroun',
      Canada: 'Canada',
      Chile: 'Chili',
      China: 'Chine',
      Cyprus: 'Chypre',
      Colombia: 'Colombie',
      Comoros: 'Comores',
      'Congo - Brazzaville': 'Congo-Brazzaville',
      'Congo - Kinshasa': 'Congo-Kinshasa',
      'North Korea': 'Corée du Nord',
      'South Korea': 'Corée du Sud',
      'Costa Rica': 'Costa Rica',
      'Ivory Coast': 'Côte d’Ivoire',
      Croatia: 'Croatie',
      Cuba: 'Cuba',
      Curaçao: 'Curaçao',
      Denmark: 'Danemark',
      Djibouti: 'Djibouti',
      Dominica: 'Dominique',
      'Dominican Republic': 'République dominicaine',
      Ecuador: 'Équateur',
      Egypt: 'Égypte',
      'United Arab Emirates': 'Émirats arabes unis',
      Eritrea: 'Érythrée',
      Spain: 'Espagne',
      Eswatini: 'Eswatini',
      Estonia: 'Estonie',
      'United States': 'États-Unis',
      Ethiopia: 'Éthiopie',
      Fiji: 'Fidji',
      Finland: 'Finlande',
      France: 'France',
      Gabon: 'Gabon',
      Gambia: 'Gambie',
      Georgia: 'Géorgie',
      Ghana: 'Ghana',
      Gibraltar: 'Gibraltar',
      Greece: 'Grèce',
      Grenada: 'Grenade',
      Greenland: 'Groenland',
      Guadeloupe: 'Guadeloupe',
      Guam: 'Guam',
      Guatemala: 'Guatemala',
      Guernsey: 'Guernesey',
      Guinea: 'Guinée',
      'Guinea-Bissau': 'Guinée-Bissau',
      'Equatorial Guinea': 'Guinée équatoriale',
      Guyana: 'Guyana',
      'French Guiana': 'Guyane française',
      Haiti: 'Haïti',
      Honduras: 'Honduras',
      'Hong Kong': 'Hong Kong',
      Hungary: 'Hongrie',
      Iceland: 'Islande',
      India: 'Inde',
      Indonesia: 'Indonésie',
      Iraq: 'Irak',
      Iran: 'Iran',
      Ireland: 'Irlande',
      'Isle of Man': 'Île de Man',
      Italy: 'Italie',
      Jamaica: 'Jamaïque',
      Japan: 'Japon',
      Jersey: 'Jersey',
      Jordan: 'Jordanie',
      Kazakhstan: 'Kazakhstan',
      Kenya: 'Kenya',
      Kiribati: 'Kiribati',
      Kuwait: 'Koweït',
      Kyrgyzstan: 'Kirghizistan',
      Laos: 'Laos',
      Latvia: 'Lettonie',
      Lebanon: 'Liban',
      Lesotho: 'Lesotho',
      Liberia: 'Libéria',
      Libya: 'Libye',
      Liechtenstein: 'Liechtenstein',
      Lithuania: 'Lituanie',
      Luxembourg: 'Luxembourg',
      Macao: 'Macao',
      'North Macedonia': 'Macédoine du Nord',
      Madagascar: 'Madagascar',
      Malawi: 'Malawi',
      Malaysia: 'Malaisie',
      Maldives: 'Maldives',
      Mali: 'Mali',
      Malta: 'Malte',
      'Marshall Islands': 'Îles Marshall',
      Martinique: 'Martinique',
      Mauritania: 'Mauritanie',
      Mauritius: 'Maurice',
      Mayotte: 'Mayotte',
      Mexico: 'Mexique',
      Micronesia: 'Micronésie',
      Moldova: 'Moldavie',
      Monaco: 'Monaco',
      Mongolia: 'Mongolie',
      Montenegro: 'Monténégro',
      Montserrat: 'Montserrat',
      Morocco: 'Maroc',
      Mozambique: 'Mozambique',
      Myanmar: 'Myanmar',
      Namibia: 'Namibie',
      Nauru: 'Nauru',
      Nepal: 'Népal',
      Netherlands: 'Pays-Bas',
      'New Caledonia': 'Nouvelle-Calédonie',
      'New Zealand': 'Nouvelle-Zélande',
      Nicaragua: 'Nicaragua',
      Niger: 'Niger',
      Nigeria: 'Nigeria',
      Niue: 'Niue',
      'Norfolk Island': 'Île Norfolk',
      'Northern Mariana Islands': 'Îles Mariannes du Nord',
      Norway: 'Norvège',
      Oman: 'Oman',
      Pakistan: 'Pakistan',
      Palau: 'Palaos',
      Palestine: 'Palestine',
      Panama: 'Panama',
      'Papua New Guinea': 'Papouasie-Nouvelle-Guinée',
      Paraguay: 'Paraguay',
      Peru: 'Pérou',
      Philippines: 'Philippines',
      'Pitcairn Islands': 'Îles Pitcairn',
      Poland: 'Pologne',
      Portugal: 'Portugal',
      'Puerto Rico': 'Porto Rico',
      Qatar: 'Qatar',
      Romania: 'Roumanie',
      Russia: 'Russie',
      Rwanda: 'Rwanda',
      Réunion: 'Réunion',
      'Saint Barthélemy': 'Saint-Barthélemy',
      'Saint Helena': 'Sainte-Hélène',
      'Saint Kitts and Nevis': 'Saint-Kitts-et-Nevis',
      'Saint Lucia': 'Sainte-Lucie',
      'Saint Martin': 'Saint-Martin',
      'Saint Pierre and Miquelon': 'Saint-Pierre-et-Miquelon',
      'Saint Vincent and the Grenadines': 'Saint-Vincent-et-les-Grenadines',
      Samoa: 'Samoa',
      'San Marino': 'Saint-Marin',
      'Sao Tome and Principe': 'Sao Tomé-et-Principe',
      Senegal: 'Sénégal',
      Serbia: 'Serbie',
      Seychelles: 'Seychelles',
      'Sierra Leone': 'Sierra Leone',
      Singapore: 'Singapour',
      'Sint Maarten': 'Saint-Martin',
      Slovakia: 'Slovaquie',
      Slovenia: 'Slovénie',
      'Solomon Islands': 'Îles Salomon',
      Somalia: 'Somalie',
      'South Georgia and the South Sandwich Islands':
        'Géorgie du Sud-et-les Îles Sandwich du Sud',
      'South Sudan': 'Soudan du Sud',
      'Sri Lanka': 'Sri Lanka',
      Sudan: 'Soudan',
      Suriname: 'Suriname',
      'Svalbard and Jan Mayen': 'Svalbard et Jan Mayen',
      Swaziland: 'Eswatini',
      Sweden: 'Suède',
      Switzerland: 'Suisse',
      Syria: 'Syrie',
      Taiwan: 'Taïwan',
      Tajikistan: 'Tadjikistan',
      Tanzania: 'Tanzanie',
      Thailand: 'Thaïlande',
      'Timor-Leste': 'Timor-Leste',
      Togo: 'Togo',
      Tokelau: 'Tokelau',
      Tonga: 'Tonga',
      'Trinidad and Tobago': 'Trinité-et-Tobago',
      Tunisia: 'Tunisie',
      Turkey: 'Turquie',
      Turkmenistan: 'Turkménistan',
      Tuvalu: 'Tuvalu',
      Uganda: 'Ouganda',
      Ukraine: 'Ukraine',
      'United Kingdom': 'Royaume-Uni',
      Uruguay: 'Uruguay',
      Uzbekistan: 'Ouzbékistan',
      Vanuatu: 'Vanuatu',
      'Vatican City': 'Vatican',
      Venezuela: 'Venezuela',
      Vietnam: 'Viêt Nam',
      'Western Sahara': 'Sahara occidental',
      Yemen: 'Yémen',
      Zambia: 'Zambie',
      Zimbabwe: 'Zimbabwe',
    };
    return translations[name] || name;
  }
  getListcandidat() {
    this.spinner.show();
      const params = {
        id: this.idoffre,
        per_page: this.pageSize,
        page: this.currentPage 
      }    
    this.candidatservice.getListcandidatureinterne(params).subscribe({
      next: (response) => {
        if (response.data && response.data.data) {
          // this.searchCandidat();
          this.listcandidats = response.data.data;
          this.totalItems = response.data?.total;
          this.spinner.hide();
        }
      },
      error: (error) => {
        this.spinner.hide();
      },
    });
  }
  getSkillsArray(c: any): string[] {
    if (c?.candidate_skills?.length > 0) {
      return c.candidate_skills.split(',').map((s: string) => s.trim());
    } else {
      return [];
    }
  }
  getSkillsList(candidate_skills: string): string {
    if (!candidate_skills) {
      return '';
    }
    return candidate_skills.split(',').map(s => s.trim()).join(', ');
  }
 getListElementHeader() {
      this.candidatservice
        .getHeaderElements(33)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            this.isLoadSpinner = false;
            this.dataHeader = res.data;
            for (const iterator of this.dataHeader) {
              const nameLower = iterator.name?.toLowerCase?.();

              if (
                !(nameLower === 'score barème' && iterator.checked_user === null) &&
                (
                  (iterator.checked === 'oui' && !iterator.checked_user) ||
                  (iterator.checked === 'non' && iterator.checked_user === 'oui') ||
                  (iterator.checked === 'oui' && iterator.checked_user === 'oui')
                )
              ) {
                this.listNames.push(iterator.name);
              }
            }
            this.dataHeader.map((el: any) => {
              if (el.name.toLowerCase() === 'score barème' && el.checked_user === null) {
                return (el.checkAdmin = false);
              } else if (
                (el.checked == 'oui' && !el.checked_user) ||
                (el.checked_user == 'oui' &&
                  (el.checked == 'non' || el.checked == 'oui'))
              ) {
                return (el.checkAdmin = true);
              } else {
                return (el.checkAdmin = false);
              }
            });
          },
          error: () => {},
        });
      }

  

 
changeSelection(event: any, data: any, i: number) {
  if(data?.name?.toLowerCase() ==="score barème" && event.target.checked){
    Swal.fire({
          title: `Conformément à la réglementation RGPD, cette fonctionnalité ne peut être activée que si vous avez reçu plus de 50 candidatures. Souhaitez-vous continuer ?`,
          icon: 'info',
          showCancelButton: true,
          confirmButtonText: 'Confirmer',
          cancelButtonText: 'Annuler',
          reverseButtons: true,
          iconColor: '#265D91',
          confirmButtonColor: '#265D91',
        }).then((result) => {
          if (result.isConfirmed) {
            this.toastrService.success('La colonne "Score Barème" a été activée avec succès.');
            this.listNames = [];
            data.checkAdmin = event.target.checked;
            for (const iterator of this.dataHeader) {
              if (iterator.checkAdmin) this.listNames.push(iterator.name);
            }
            this.changeSelectionHeadrElements(data);
          } else {
            event.target.checked = false; // Annuler la sélection
            data.checkAdmin = false;
            this.listNames = [];
            for (const iterator of this.dataHeader) {
              if (iterator.checkAdmin) this.listNames.push(iterator.name);
            }
          }
        });
  } else{    
    this.listNames = [];
    data.checkAdmin = event.target.checked;
    for (const iterator of this.dataHeader) {
      if (iterator.checkAdmin) this.listNames.push(iterator.name);
    }
    this.changeSelectionHeadrElements(data);

  }
}

changeSelectionHeadrElements(data: any) {
    let payload = {
      sub_page_id: data?.id,
      state: data?.checkAdmin? 1 : 0,
    };
    this.candidatservice
      .changeDelectedElementHeader(payload)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {},
        error: () => {},
      });
}
getRemainingPays(pay: any): string {
  if (!Array.isArray(pay) || pay.length <= 3) {
    return ''; 
  }
  return pay.map(m => String(m)).join(', '); 
}
  downloadFile(type: string, candidat?: any, typeFile?: string) {
    if (type == 'single' && candidat) {
      if (candidat.cv || candidat.file_test) {
        if (typeFile && typeFile != '')
          candidat.file_test = candidat.file_test.split('/')[1];
        const fileUrl = !typeFile
          ? `${this.url}/User/file/gallery_cvs/${candidat.cv}`
          : `${this.url}/ResponseCandidate/GetFile/${candidat.file_test}`; // Replace with your file URL
        this.showGlobalSpinner();
        this.candidatservice.downloadPDF(fileUrl).subscribe(
          (data) => {
            const blob = new Blob([data], { type: 'application/octet-stream' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = !typeFile
              ? `${candidat.ID_user}_${candidat.first_name}_${
                  candidat.last_name
                }_CV.${candidat!.cv.split('.').pop()}`
              : `${candidat.ID_user}_${candidat.first_name}_${
                  candidat.last_name
                }_QCM.${candidat!.file_test.split('.').pop()}`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            this.hideGlobalSpinner();
          },
          () => {
            this.hideGlobalSpinner();
          }
        );
      } else {
        this.toastrService.info(EmptyCV);
      }
    } else if (this.selectedCandidats.length) {
      if (this.selectedCandidats.length == 1 && !this.selectedCandidats[0].cv) {
        this.toastrService.info(EmptyCV);
      } else this.downloadPdfFiles(typeFile);
    } else {
      this.toastrService.info(obligationSelect);
    }
  }
  /* download files in zip folder */
  downloadPdfFiles(typeFile?: string) {
    const zip = new JSZip();
    const fileUrls = this.selectedCandidats.map(
      (el: {
        cv: string;
        file_test: string;
        first_name: string;
        last_name: string;
        ID_user: string;
      }) => {
        if (!typeFile) {
          return {
            url: `${this.url}/User/file/gallery_cvs/${el.cv}`,
            first_name: el.first_name,
            last_name: el.last_name,
            ID_user: el.ID_user,
            cv: el.cv,
          };
        } else {
          // if(el.file_test!=null)
          return {
            url: `${this.url}/ResponseCandidate/GetFile/${
              el?.file_test?.split('/')[1]
            }`,
            first_name: el.first_name,
            last_name: el.last_name,
            ID_user: el.ID_user,
            response: el?.file_test?.split('/')[1],
          };
        }
      }
    );
    this.showGlobalSpinner();
    const downloadPromises = fileUrls.map((pdfUrl: any) => {
      return this.candidatservice
        .getPdfContent(pdfUrl.url)
        .toPromise()
        .then(
          (pdfContent: any) => {
            this.hideGlobalSpinner();
            zip.file(
              !typeFile
                ? `${pdfUrl.ID_user}_${pdfUrl.first_name}_${
                    pdfUrl.last_name
                  }_CV.${pdfUrl.cv.split('.').pop()}`
                : `${pdfUrl.ID_user}_${pdfUrl.first_name}_${
                    pdfUrl.last_name
                  }_QCM.${pdfUrl.response.split('.').pop()}`,
              pdfContent
            );
          },
          (err: any) => {
            this.hideGlobalSpinner();
          }
        );
    });

    Promise.all(downloadPromises).then(() => {
      zip.generateAsync({ type: 'blob' }).then((content) => {
        if (!typeFile) {
          saveAs(content, 'RH_Profiles_CVs.zip'); // Specify the zip file name here
        } else {
          saveAs(content, 'RH_Profiles_QCMs.zip');
        }
      });
    });
  }

 
  showGlobalSpinner() {
    this.loadSpinner = true;
    this.spinner.show();
  }
  hideGlobalSpinner() {
    this.loadSpinner = false;
    this.spinner.hide();
  }
  downloadreponse(candidat: any) {
    // if(!this.selectedCandidate.cv) {this.toastr.info(EmptyCV)}
    // else{
    this.spinner.show();
    const fileUrl = `${this.url}/User/file/gallery_cvs/${candidat.file_test}`;
    this.candidatservice.downloadPDF(fileUrl).subscribe((blob) => {
      const fileURL = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = fileURL;
      a.download = `${candidat.ID_user}_${candidat.first_name}_${
        candidat.last_name
      }_CV.${candidat.cv.split('.').pop()}`;
      document.body.appendChild(a);
      a.click();
      this.spinner.hide();
    });
    // }
  }
  /* get candidats selected */
  fromSelection: boolean = false;
  changeSelectCandidats(event: any, type: string, candidat?: ICandidat) {
    if (type === 'allCandidats') {
      this.fromSelection = event.target.checked ? true : false;
      this.headerChecked = event.target.checked;
      this.selectedCandidats = event.target.checked
        ? [...this.listcandidats]
        : [];

      // Mettez à jour la propriété checked pour chaque candidat dans selectedCandidats
      this.selectedCandidats.forEach((el: ICandidat) => {
        el.checked = event.target.checked;
      });
    } else {
      if (candidat) {
        if (event.target.checked) {
          this.selectedCandidats.push(candidat);
          candidat.checked = true; // Mettez à jour la propriété checked pour le candidat spécifique
        } else {
          let indexId = this.selectedCandidats.findIndex(
            (el: { uuid: string }) => {
              return el.uuid == candidat.uuid;
            }
          );
          if (indexId !== -1) {
            this.selectedCandidats.splice(indexId, 1);
            candidat.checked = false; // Mettez à jour la propriété checked pour le candidat spécifique
          }
        }
      }
    }
  }

  getListSkills() {
    this.salarieservice.getSkills().subscribe({
      next: (res) => {
        this.skillsList = res.data;
      },
      error: () => {
        this.toastrService.error(serverError);
      },
    });
  }
  onSalaryRangeInput(event: any) {
    const value = event.target.value;
    if (value.toLowerCase().endsWith('k')) {
      this.searchForm.controls['desired_salary_range'].setValue(
        this.convertKToNumber(value)
      );
    }
  }
 
 alreadyConverted = false;
 convertKToNumber(value: any): number {
  if (typeof value === 'string' && value.toLowerCase().endsWith('k')) {
    // Si la valeur se termine par 'k'
    const numericValue = parseFloat(value.slice(0, -1));
    if (!isNaN(numericValue)) {
      // Convertir en multipliant par 1000
      this.alreadyConverted = true; // Marquer comme déjà convertie
      return numericValue * 1000;
    }
  } else if (!isNaN(value)) {
    // Si la valeur est déjà un nombre
    if (!this.alreadyConverted) {
      this.alreadyConverted = true; // Marquer comme déjà convertie
      return parseFloat(value) * 1000;
    } else {
      return parseFloat(value); // Retourner la valeur sans multiplier à nouveau
    }
  }

  // Si aucune condition n'est remplie, retourner une valeur par défaut
  return 0; // Ou une autre valeur par défaut appropriée
}
  createSearchForm(data?: any) {
    return this.formBuilder.group({
      name: ['', data?.name],
      years_of_experience: ['', data?.years_of_experience],
      experience_range: ['', data?.experience_range],
      desired_contract: [[], data?.desired_contract],
      desired_salary: ['', data?.desired_salary],
      desired_salary_range: ['', data?.desired_salary_range],
      tjm: ['', data?.tjm],
      tjm_range: ['', data?.tjm_range],
      post_type: [[], data?.post_type],
      skillsOr: [[], data?.skillsOr],
      skillsAnd: [[], data?.skillsAnd],
      country: [[], data?.country],
      city: [[], data?.city],
      availability: [[], data?.availability],
      start_date: ['', data?.start_date],
      end_date: ['', data?.end_date],
      
    });
  }
  /* search */
  searchCandidat(pageNumber : number = this.currentPage) {
    this.btnSearchactive = true;
    let valueForm = this.searchForm.value;
    if (valueForm.desired_salary_range != null) {
      valueForm.desired_salary_range = this.convertKToNumber(
        valueForm.desired_salary_range.toString()
      );
    }
    let data = {
      name: valueForm.name,
      skillsOr: valueForm.skillsOr,
      skillsAnd: valueForm.skillsAnd,
      years_of_experience: this.searchForm.value.years_of_experience,
      experience_range: valueForm.experience_range,
      desired_contract: this.searchForm.value.desired_contract,
      desired_salary: this.searchForm.value.desired_salary,
      desired_salary_range: this.searchForm.value.desired_salary_range,
      availability: valueForm.availability,
      tjm: valueForm.tjm,
      tjm_range: valueForm.tjm_range,
      post_type: valueForm.post_type,
      country: valueForm.country ? valueForm.country : '',
      city: valueForm.city ? valueForm.city : '',
      current_country: valueForm.current_country
        ? valueForm.current_country
        : '',
      mobility: valueForm.city ? valueForm.mobility : '',
      start_date: valueForm.start_date,
      end_date: valueForm.end_date,
      per_page: this.pageSize,
      page: this.currentPage + 1,
    };
    console.log("searchCandidat data", data);
    
    this.spinner.show();
    this.candidatservice
      .searchcandidatureinterne(this.idoffre, data)
      .subscribe({
        next: (resSearch) => { 
            this.listcandidats = resSearch.data.data;

            this.listcandidats.map((candidate: any) => {
              candidate.candidate_skills = candidate?.skills?.map((item: any) => item.sub_category?.name_FR).filter(Boolean).join(', ');
            });
            
            this.totalItems = resSearch.data?.total;
            this.spinner.hide();
        },
        error: (error) => {
          this.toastrService.error(serverError);
          this.spinner.hide();
        },
      });
  }

   freeSearchCandidat(pageNumber: number = this.currentPage) {
    let valueForm = this.freeSearchForm.value;
    let data = {
      page: this.currentPage + 1,
      per_page: this.pageSize,
      search: this.transformSearch(valueForm?.search),
    }
    this.spinner.show();
    this.candidatservice.searchcandidatureinterne(this.idoffre, data).subscribe({
          next: (resSearch) => {
              const { to, from, total, current_page, data } = resSearch.data;
              this.spinner.hide();
              this.startSearching = false;
              this.listcandidats= resSearch.data.data;
              this.listcandidats.map((candidate: any) => {
                candidate.candidate_skills = candidate?.skills?.map((item: any) => item.sub_category?.name_FR).filter(Boolean).join(', ');
              });
              this.totalItems = resSearch.data.total;
              this.spinner.hide();
          },
          error: (error) => {
              this.spinner.hide();
          },
      });
  }
 
  transformSearch(search: string): string {
    // Remplace toutes les occurrences de '||' par 'OR'
    search = (search || '').replace(/\|\|/g, ' OR ');

    // Remplace toutes les occurrences de '&&' par ' AND '
    search = search.replace(/&&/g, ' AND ');

    // Remplace toutes les occurrences de '!' par ' NOT '
    search = search.replace(/!/g, ' NOT ');

    // Ajoute des espaces autour des opérations logiques pour éviter des conflits avec les mots
    search = search.replace(/\b(AND|OR|NOT)\b/g, ' $1 ');

    // Remplace les termes entre guillemets doubles par les mêmes termes sans modification
    // et échappe les guillemets simples à l'intérieur des termes non compris entre guillemets
    search = search.replace(/"([^"]+)"|(\S+)/g, (match, p1, p2) => {
      if (p1) {
        return `"${p1}"`;
      } else {
        // Si le terme n'est pas entre guillemets, échappe les guillemets simples à l'intérieur du terme
        const escapedTerm = p2.replace(/"/g, '\\"');
        return `${escapedTerm}`;
      }
    });

    // Supprime les espaces en double pour une meilleure lisibilité
    search = search.replace(/\s+/g, ' ');

    // Renvoie la chaîne de recherche transformée
    return search.trim();
  }

  isSimpleWord(value: string): boolean {
    const simpleWordPattern = /^[a-zA-Z0-9]+(\s[a-zA-Z0-9]+)?$/;
    return simpleWordPattern.test(value);
  }

  /* change country select and delete the string Governorate from state name*/
onCountryChange(mode: string): void {
  
    this.searchForm.get('city')?.enable();
    this.countries = this.searchForm.get('country')?.value;
    this.countries = this.countries.map(
      (item: any) => this.paysList.filter((it) => it.name === item)[0]
    );

    this.stateList.length = 0;
    // if (event.length) {
    this.countries.forEach((item: any) => {
      this.stateList.push(State.getStatesOfCountry(item.isoCode));
    });
    this.stateList = this.stateList.flat();
    for (const iterator of this.stateList) {
      iterator.name = iterator.name.replace(' Governorate', '');
    }
    this.stateList = this.stateList.map((item: any) => item.name);
    this.mobilities = this.searchForm.get('city')?.value;
    if (this.mobilities != null && this.mobilities.length > 0) {
      let differentItemsArray1: any[] = [];
      differentItemsArray1 = this.mobilities.filter(
        (item) => !this.stateList.includes(item)
      );
      const differentItemsArray2 = this.mobilities.filter(
        (item) => !differentItemsArray1.includes(item)
      );
      this.searchForm.get('city')?.setValue(differentItemsArray2);
    }
    // }
    if (this.stateList.length == 0) {
      this.stateList = [];
      mode == 'add';
      this.searchForm.get('city')?.setValue(null);
    }
  }
onMobilityChange(mode: string) {

    this.mobilities = this.searchForm.get('city')?.value;
    let paysLists: any[] = [];
    this.countries = this.searchForm.get('country')?.value;
    this.countries = this.countries.filter(async (item: any) => {
      paysLists.push(this.paysList.filter((it) => it.name === item)[0]);
    });
    let stateListAfter1: any[] = [];
    paysLists.forEach((item) => {
      let stateListAfter: any[] = [];
      stateListAfter = State.getStatesOfCountry(item.isoCode);
      let difference1: any[] = [];
      if (this.countries.length > 0) {
        difference1 = this.findDuplicates(
          this.mobilities,
          stateListAfter.map((item) => item.name)
        );
        if (difference1.length == 0) {
          let index = this.countries.indexOf(item.name);
          if (index !== -1) {
            let new_array = this.countries
              .slice(0, index)
              .concat(this.countries.slice(index + 1));
            this.stateList = this.stateList.filter(
              (item: any) =>
                !stateListAfter.map((item) => item.name).includes(item)
            );

            // this.searchForm.get('country')?.setValue(new_array);
          }
        }
      }
    });
    //  this.stateList=stateListAfter1

    this.mobilities = this.searchForm.get('city')?.value;
    if (this.mobilities.length === 0 || this.stateList.length === 0) {
      this.searchForm.get('city')?.disable();
      mode == 'add';
      this.searchForm.get('country')?.setValue(null);
      mode == 'add';
      this.searchForm.get('city')?.setValue(null);
      this.searchForm.get('country')!.updateValueAndValidity();
      this.searchForm.get('city')!.updateValueAndValidity();
      this.stateList.length = 0;
    }
  }
findDuplicates(array1: any, array2: any) {
    let occurrences: any[] = [];
    let duplicates: any = [];
    for (let element of array1) {
      occurrences[element] = (occurrences[element] || 0) + 1;
    }
    for (let element of array2) {
      if (occurrences[element] && !duplicates.includes(element)) {
        duplicates.push(element);
      }
    }

    return duplicates;
  }
  reset() {
    this.currentPage = 0;
    this.freeSearchForm.reset();
    this.searchForm.reset();
    this.freeSearchForm = this.createFreeSearchForm();
    this.searchForm = this.createSearchForm();
    this.getListcandidat();
    this.searchForm.get('start_date')?.valueChanges.subscribe((startDate) => {
      this.minEndDate = startDate ? new Date(startDate) : null;
    });
    this.searchForm.get('end_date')?.valueChanges.subscribe((endDate) =>{
      this.maxStartDate = endDate ? new Date(endDate) : null;
    })
  }

  ngOnDestroy() {
    const scrollableTable = this.elRef.nativeElement.querySelector('#kt_customers_table');
    scrollableTable?.addEventListener('scroll', this.closeDropdownOnScroll.bind(this));
  }

  //TOFIX : duplicated
   /**
   * Returns a string list of contract types for tooltip display based on contract type codes.
   * @param contractTypes - An array of contract type codes.
   * @returns A string listing the contract type names.
   */
   getContractTypeList(contractTypes: number[]): string {
    const contractMap: { [key: string]: string } = {
        '1': 'Alternance',
        '2': 'Autres type de contrat',
        '3': 'CDD',
        '4': 'CDI',
        '5': 'Freelance',
        '6': 'Portage salarial',
        '7': 'Stage'
    };

    return contractTypes.map(type => contractMap[type.toString()] || '').join(', ');
  }

  downloadResponseFile(type: string, candidate : any) {
    let fileUrl = `${this.url}`
    if(type === this.companyTypeEnum.ESN){
      fileUrl = fileUrl.concat(`/TestJob/GetFileESNTest/${candidate?.file_test_esn}`)
    } else{
      fileUrl = fileUrl.concat(`/ResponseCandidate/GetFile/${candidate?.file_test}`)
    }

    this.showGlobalSpinner();
    this.candidatservice.downloadFile(fileUrl).subscribe(
      (data) => {
        const blob = new Blob([data], { type: 'application/octet-stream' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${candidate.first_name}_${candidate.last_name}-Réponses_Test_QCM_WEGESTU.pdf`
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        this.hideGlobalSpinner();
      },
      () => {
          this.hideGlobalSpinner();
      }
    );
  }

  closeModalScore() {
    let btnClose = document.getElementById('ModalCloseScore');
    if (btnClose) {
      btnClose.click();
    }
  }

  openModalScore(candidate : any){
    this.jobofferservice.getDetailScore(this.idoffre, candidate?.uuid).subscribe({
      next: (res: any) => {
        this.candidateScoreDetail = res?.data
      },
      error: (error) => {
      },
    });
  }

  openModals() {
    this.showModal = true;
  }

  closeModals() {
    this.showModal = false;
  }

  addAsConsultantNavigation(consultant: any) {    
    this.router.navigate(['/consultants/ajout-consultant/'], {
      state: {
        data: { type: '1', email: consultant?.email }
      },
    });
  }
}
